import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Route, Switch } from "react-router-dom";
import useErrorBoundary from "use-error-boundary";

import { ApiContextProvider } from "./api";
import { Chat } from "./components/chat/Chat";
import { ChatHistoryNavbar } from "./components/chat/ChatHistoryNavbar";
import { ChatLayout } from "./components/layout/ChatLayout";
import MaiteThemeProvider from "./components/theme";
import { ChatContextProvider } from "./context/ChatContext";

// Create a query client instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      retry: 1,
    },
  },
});

// Error fallback component
const ErrorFallback = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h2>Something went wrong</h2>
    <p>Please refresh the page or try again later.</p>
  </div>
);

export const MaiteRouter = () => {
  const { ErrorBoundary, didCatch } = useErrorBoundary({
    onDidCatch(error, errorInfo) {
      console.error("Maite Error:", error, errorInfo);
      // TODO: Add proper error reporting (e.g., Sentry, OpenTelemetry)
    },
  });

  if (didCatch) {
    return <ErrorFallback />;
  }

  return (
    <ErrorBoundary>
      <ApiContextProvider>
        <QueryClientProvider client={queryClient}>
          <MaiteThemeProvider>
            <ChatContextProvider>
              <Switch>
                <Route exact path="/maite-v2">
                  <ChatLayout sidebar={<ChatHistoryNavbar />}>
                    <Chat />
                  </ChatLayout>
                </Route>
                <Route path="/maite-v2/:chatId">
                  <ChatLayout sidebar={<ChatHistoryNavbar />}>
                    <Chat />
                  </ChatLayout>
                </Route>
              </Switch>
            </ChatContextProvider>
            {/* Show React Query DevTools in development */}
            <ReactQueryDevtools initialIsOpen={false} />
          </MaiteThemeProvider>
        </QueryClientProvider>
      </ApiContextProvider>
    </ErrorBoundary>
  );
};
